import Immutable from 'immutable';

// constants
import { PASSWORD_RESET_CLEAR, PASSWORD_RESET_CREATE, PASSWORD_RESET_UPDATE } from '../constants/passwordResetTypes';

// lib
import httpReducer from '../lib/httpReducer';

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case PASSWORD_RESET_CLEAR:  return Immutable.Map();
    case PASSWORD_RESET_CREATE: return httpReducer(state, action);
    case PASSWORD_RESET_UPDATE: return httpReducer(state, action);
    default:                    return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/passwordReset.js